import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import CompanyFactory from "../../Entity/Factories/CompanyFactory";

export default function* companyForCompanyDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `companies/${action.payload?.companyId}`);

    const company = CompanyFactory.create(res.data.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, company);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchCompanyForCompanyDetailsPage() {
  yield takeEvery(Constants.GLOBAL_COMPANY_FOR_COMPANY_DETAILS_PAGE, companyForCompanyDetailsPage);
}
